import logo from './time.gif';
import './App.css';
import Container from 'react-bootstrap/Container';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import React, { Component } from 'react';
import Swal from 'sweetalert2';

class Main extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      isConnected: false,
    };
  }

  handleConnect = async() => {
    try{
      const accounts = await window.ethereum.request({ method: 'eth_requestAccounts'});

      if(accounts.length > 0){
        this.setState({ isConnected: true});
        Swal.fire("Berjaya!!", "Metamask berjaya dihubungkan", "success");
      } else {
        console.error('Metamask connection denied or failed');
        Swal.fire("Ralat!!","Hubungan Metamask gagal","error");
      }
    } catch(error) {
      console.error('Metamask connection error:' , error);
      Swal.fire("Ralat!!","Hubungan Metamask gagal","error");
    }
  };
  
  render() {
    return (
      <Container fluid>
          <Row>
              <Col>
                  <div className='App'>
                  <header className="App-header">
                      <img src={logo} className="App-logo" alt="logo" />
                      <p>
                      Selamat Datang Ke Blockchain Johor 
                      </p>
                      {(this.state.isConnected == true) ? (
                        <div>
                          <p>You are connected to Metamask.</p>
                          <Link to="/CreateAccount">
                            <Button variant='success'>Create Account</Button>
                          </Link>
                        </div>
                    ) : (
                        <div>
                          <Badge bg='danger'>Please connect to your wallet.</Badge><br />
                          <Button variant='primary' onClick={this.handleConnect}>Connect</Button>
                        </div>
                      )}
                  </header>
                  </div>
              </Col>
          </Row>
      </Container>
    );
  }
}

export default Main;
